<template>
  <div class="all-artists__dropdown">
    <dropdown-sub
      v-model="sort"
      :options="values"
      :placeholder="placeholder"/>
  </div>
</template>


<script>
  import dropdownSub from "../../lib/dropdownSub";
  import SortTypeMix from "../../../../../components/list/filter/SortTypeMix";

  export default {
    components: { dropdownSub },
    name      : 'sort-artists-type-sub',
    mixins: [SortTypeMix],

    data() {
      return {
        valuesObj: {
          popular: {
            value: 'popular',
            label: this.$t("message.PopularFirst").toLowerCase(),
            labelShort: this.$t("message.PopularFirstShort").toLowerCase()
          },
          abc: {
            value: 'abc',
            label: this.$t("message.Alphabetically").toLowerCase(),
            labelShort: this.$t("message.Alphabetically").toLowerCase()
          },
          new: {
            value: 'new',
            label: this.$t("message.NewFirst").toLowerCase(),
            labelShort: this.$t("message.NewFirstShort").toLowerCase()
          },
          old: {
            value: 'old',
            label: this.$t("message.OldFirst").toLowerCase(),
            labelShort: this.$t("message.OldFirstShort").toLowerCase()
          },
          period: {
            value: 'period',
            label: this.$t("message.ByYear").toLowerCase(),
            labelShort: this.$t("message.ByYear").toLowerCase()
          },
        },
      }
    },

    computed  : {
      values() {
        let res=[];

        res = [
          this.valuesObj.popular,
          this.valuesObj.new,
          //this.valuesObj.old,
          //this.valuesObj.expert,
          this.valuesObj.abc,
          this.valuesObj.period,
        ];

        res[0].value='';

        return res;
      },
    },

    methods: {
      get_value() {
        let val_str='';
        if (typeof this.value === 'object') val_str=this.value.value;

        return val_str;
      },

      set_val(new_val){
        //console.log(new_val);
        //this.$emit('input', new_val);
        //this.onChange ? this.onChange(new_val) : null;
      },
    },

  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/list/filter/SortArtistsTypeSub.vue